import { Coordinate, PDFRaster, Project } from "@nova/protobuf"
import {
    booleanValidator,
    coordinatesValidators,
    createLayerValidator,
    entityValidator,
    indexValidators,
    nameValidators,
    parentIdValidators,
    UnionToTuple,
} from "../util"
import { dateAsNumber } from "../../util"
import { createNewLayerFractionalIndex } from "../../util/fractional_indexing"

export const createPDFRasterValidator = createLayerValidator(PDFRaster, {
    filename: {
        validators: [
            {
                validator: (filename: string) => filename.length > 0,
                error: "PDFRaster filename must not be empty",
            },
            {
                validator: (filename: string) => filename.length <= 100,
                error: "PDFRaster filename cannot be greater than 100 characters",
            },
        ],
        nonNull: true,
    },
    corners: {
        validators: [
            {
                validator: (corners: Coordinate[]) => corners.length === 4,
                error: "PDFRaster 4 corner coordinates must be supplied",
            },
            ...coordinatesValidators,
        ],
        nonNull: true,
    },
    tiled: {
        validators: booleanValidator("tiled"),
    },
})

export const updatePDFRasterValidator = entityValidator(PDFRaster, {
    name: {
        validators: nameValidators,
        nonNull: true,
    },
    index: { validators: indexValidators, nonNull: true },
    parentId: { validators: parentIdValidators },
    filename: {
        validators: [
            {
                validator: (filename: string) => filename.length > 0,
                error: "PDFRaster filename must not be empty",
            },
            {
                validator: (filename: string) => filename.length <= 64,
                error: "PDFRaster filename cannot be greater than 64 characters",
            },
        ],
        nonNull: true,
    },
    tiled: {
        validators: booleanValidator("tiled"),
    },
})

export const getDefaultPDFRasterCreateArgs = (project: Project, inParentId?: string) => ({
    createdAt: dateAsNumber(),
    index: createNewLayerFractionalIndex(project, 0, inParentId),
    // parentId would never got autopopulated
    parentId: undefined,
})

export type CreatePDFRasterArgs = UnionToTuple<keyof typeof createPDFRasterValidator>
export type UpdatePDFRasterArgs = UnionToTuple<keyof typeof updatePDFRasterValidator>
